import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

export type ExpensesListPageLayoutProps = {
  children: React.ReactNode
  useDataCollectionLayout?: boolean
}

export const ExpensesListPageLayout = ({
  children,
  useDataCollectionLayout = false,
}: ExpensesListPageLayoutProps) => {
  if (!useDataCollectionLayout) {
    return <ResponsivePage.Body variant="full">{children}</ResponsivePage.Body>
  }

  // DataCollection mode: ResponsivePage.Body's overflow:auto Container breaks the
  // CSS height chain needed for the sticky SyncFooter. We render it hidden to keep
  // framework integration (error boundaries, etc.) and use a sibling Box for layout.
  return (
    <>
      <Box className="hidden">
        <ResponsivePage.Body variant="fullscreen">&nbsp;</ResponsivePage.Body>
      </Box>
      <Box height="full">{children}</Box>
    </>
  )
}
